import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'

const ZOOM_STEPS = [0.5, 0.75, 1, 1.25] as const

export function ZoomControls({zoom, onZoomChange}: {zoom: number; onZoomChange: (zoom: number) => void}) {
  const {t} = useTranslation()
  const index = ZOOM_STEPS.indexOf(zoom as (typeof ZOOM_STEPS)[number])
  const canZoomOut = index > 0
  const canZoomIn = index >= 0 && index < ZOOM_STEPS.length - 1

  // `aria-label` antes de `onClick`: el check `doctrina_de_ux` (U17) lee los atributos de `<Button`
  // hasta el primer `>`, y el `=>` de la flecha lo corta.
  return (
    <div className="inline-flex items-center gap-1" data-testid="organigrama-diagrama-zoom" role="group">
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        aria-label={t('business.organigrama.diagrama.zoomOut')}
        data-testid="organigrama-diagrama-zoom-out"
        disabled={!canZoomOut}
        onClick={() => canZoomOut && onZoomChange(ZOOM_STEPS[index - 1])}>
        −
      </Button>
      <span
        className="min-w-10 text-center font-mono text-xs text-muted-foreground"
        data-testid="organigrama-diagrama-zoom-level">
        {Math.round(zoom * 100)}%
      </span>
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        aria-label={t('business.organigrama.diagrama.zoomIn')}
        data-testid="organigrama-diagrama-zoom-in"
        disabled={!canZoomIn}
        onClick={() => canZoomIn && onZoomChange(ZOOM_STEPS[index + 1])}>
        +
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onZoomChange(1)}
        data-testid="organigrama-diagrama-zoom-reset">
        {t('business.organigrama.diagrama.zoomReset')}
      </Button>
    </div>
  )
}
